export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const MARKET_DATA_ROOT = process.env.REACT_APP_MARKET_DATA_ROOT;
export const MAIL_API_ROOT = process.env.REACT_APP_MAIL_API_ROOT;
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY;
export const MIXPANEL_PROJECT_TOKEN = process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN;
export const MATRIX_REST_API = process.env.REACT_APP_MATRIX_REST_API;
export const isProdEnv = !!(process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'prod');
export const emailTemplateLink = 'https://docs.google.com/document/d/110KaEmVUiuu_JCrwMknuM8nzwmeAVMtMVprPTfci7Gg/edit?usp=sharing';
